


import React, { useState, useContext, useEffect } from "react";
import desktopIcon from "../../assets/images/desktopIcon.png";
import starIcon from "../../assets/images/star.png";
import { AuthContext } from "../../context/AuthContext";

function TherapyRoomCard({
  room,
  isSelected,
  onSelect,
  onEnterClick,
  sessions = [],
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isStarHovered, setIsStarHovered] = useState(false);
  const [selectedSession, setSelectedSession] = useState(
    sessions.find((s) => s.isAvailable || s.isUpcoming) || null
  );
  useEffect(() => {
    const newSelectedSession = sessions.find((s) => s.isAvailable || s.isUpcoming) || null;
    setSelectedSession(newSelectedSession);
  }, [sessions]);
  const primarySession = sessions.find((s) => s.isPrimary) || null;
  const filteredSessions = sessions.filter(s => s.isAvailable || s.isUpcoming);
const {
    userType,
    
  } = useContext(AuthContext);

  // ✅ Destructure from room object
  const {
    image,
    title,
    description,
    accessibility,
    style,
    available,
    isComingSoon,
    online,
  } = room;


  return (
    <div
      className={`bg-black text-white rounded-3xl shadow-lg p-6 flex flex-col mx-auto w-full max-w-[500px] md:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-auto transition-all duration-300 border-2 cursor-pointer ${
        isComingSoon
          ? " cursor-not-allowed border-[4px] border-transparent"
          : isSelected
          ? " border-[8px] border-[#22AAEE]"
          : isHovered
          ? " border-[8px] border-[#22AAEE]"
          : "border-transparent"
      }`}
      style={{
        position: "relative",
        overflow: "visible",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onSelect}
    >
      {/* Star Icon */}
      {isSelected && (
        <div
          className="absolute top-0 left-0 z-20"
          style={{ transform: "translate(-45%, -65%)" }}
          onMouseEnter={() => setIsStarHovered(true)}
          onMouseLeave={() => setIsStarHovered(false)}
        >
          <img src={starIcon} alt="Selected" className="w-13 h-12" />
          {isStarHovered && (
            <span className="absolute bg-white text-black text-xs px-2 py-2 rounded-xl shadow-lg" style={{ top: "-20px", left: "80%", zIndex: 30 }}>
              {userType === "Client" ? "Your preferred space" : "Client's preferred space"}
            </span>
          )}
        </div>
      )}

      {/* Online Badge */}
      {online && (
        <div
          className="flex items-center bg-[#D8F8FF] text-black text-sm px-3 py-1 rounded-full absolute"
          style={{
            top: "-15px",
            right: "10px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            zIndex: 10,
          }}
        >
          <span className="bg-[#22AAEE] rounded-full w-3 h-3 mr-2 inline-block"></span>
          <span>Online</span>
        </div>
      )}

      {/* Image */}
      <img src={image} alt={title} className="w-full h-48 object-cover rounded-lg mb-4" />

      {/* Title & Description */}
      <div className="mb-4" style={{ minHeight: "120px" }}>
        <h3 className="font-medium mb-2" style={{ fontSize: "var(--font-size-title)" }}>{title}</h3>
        <p className="font-medium" style={{ fontSize: "var(--font-size-description)" }}>{description}</p>
      </div>

      {/* Metadata */}
      <div style={{ minHeight: "100px" }}>
        <p className="font-medium mb-2 flex items-center" style={{ fontSize: "var(--font-size-small)" }}>
          Accessibility | {accessibility}
          <span className="inline-flex items-center ml-2">
            <img src={desktopIcon} alt="Accessibility Icon" className="w-[18px] h-[18px]" />
          </span>
        </p>
        <p className="font-medium mb-2" style={{ fontSize: "var(--font-size-small)" }}>
          Virtual Space Style | {style}
        </p>
        {selectedSession?.sessionStartTimeEST && (
          <p className="font-medium text-[#22AAEE] mt-2" style={{ fontSize: "var(--font-size-small)" }}>
             Session Start Time: {selectedSession.sessionStartTimeEST}
          </p>
        )}
        

      </div>

      {/* Session Selector + Button */}
      <div className="w-full flex flex-col justify-center mt-2 max-w-[350px] mx-auto">
  {available && filteredSessions.length > 0 ? (
    filteredSessions.length === 1 ? (
      <button
        onClick={() => onEnterClick(filteredSessions[0].meetingID)}
        className="w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white transition duration-300 shadow-md"
      >
        ENTER SESSION
      </button>
    ) : (
      <>
        <label htmlFor="sessionSelect" className="text-sm text-white mb-2 font-medium">
          Select a Session
        </label>
        <select
          id="sessionSelect"
          value={selectedSession?.meetingID || filteredSessions[0]?.meetingID || ""}
          onChange={(e) => {
            const selected = filteredSessions.find(s => s.meetingID === e.target.value);
            setSelectedSession(selected || null);
          }}
          className="w-full rounded-lg border border-[#22AAEE] bg-white text-black px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#22AAEE] transition duration-200 shadow-sm"
        >
          <optgroup label="Available Sessions">
            {filteredSessions.map((session) => (
              <option key={session.meetingID} value={session.meetingID}>
                {session.sessionStartTimeEST}
              </option>
            ))}
          </optgroup>
        </select>

        <button
          onClick={() =>
            onEnterClick(
              selectedSession?.meetingID || filteredSessions[0]?.meetingID
            )
          }
          className="mt-4 w-full font-semibold rounded-full px-6 py-3 text-sm md:text-base bg-[#D8F8FF] text-black hover:bg-[#22AAEE] hover:text-white transition duration-300 shadow-md"
        >
          ENTER SESSION
        </button>
      </>
    )
  ) : (
    <button
      disabled
      className="font-semibold rounded-full bg-gray-500 text-white w-full px-6 py-3 text-sm md:text-base cursor-not-allowed shadow-sm"
    >
      {isComingSoon ? "Coming June 16th" : "UNAVAILABLE"}
    </button>
  )}
</div>


    </div>
  );
}

export default TherapyRoomCard;

